// extracted by mini-css-extract-plugin
export default {"error":"Error_error__pvQbU","error__text":"Error_error__text__XvA3a","error__img":"Error_error__img__h31ax"};